var _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMainBackgroundDesktop = function SvgMainBackgroundDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 1262 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-desktop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930 505h251V296c0-24.853-20.15-45-45-45H930v254Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-desktop_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225 49h361v319c0 24.853-20.147 45-45 45H225V49Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-desktop_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-95 413h320v266.454c0 31.685-25.686 57.371-57.371 57.371H-95V413Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "main-background-desktop_svg__a",
    x: 881.663,
    y: 202.663,
    width: 379.898,
    height: 382.898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16.112,
    dy: 16.112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.224
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "main-background-desktop_svg__b",
    x: 176.663,
    y: 0.663,
    width: 489.898,
    height: 492.898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16.112,
    dy: 16.112
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.224
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "main-background-desktop_svg__c",
    x: -156.624,
    y: 351.376,
    width: 484.332,
    height: 488.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 20.541,
    dy: 20.541
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.083
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })))));
};

export { SvgMainBackgroundDesktop as ReactComponent };
export default __webpack_public_path__ + "76f89dbb2862cd18551d020160da837a.svg";